import React, { memo } from "react";
import { Box, FormControl, FormHelperText, InputLabel } from "@mui/material";
import { ipdLabelSx } from "./ipdFieldStyles";

function IpdFormField({
  label,
  children,
  error,
  helperText,
  className,
  required,
  id,
  sx,
}) {
  const fieldId = id || `field-${String(label || "input").replace(/\s+/g, "-").toLowerCase()}`;
  const message = error || helperText;

  return (
    <FormControl
      fullWidth
      size="small"
      error={Boolean(error)}
      className={className}
      sx={{ mb: 0, ...sx }}
    >
      {label ? (
        <InputLabel
          shrink
          htmlFor={fieldId}
          required={required}
          sx={ipdLabelSx}
        >
          {label}
        </InputLabel>
      ) : null}
      <Box id={fieldId}>{children}</Box>
      <FormHelperText
        role={error ? "alert" : undefined}
        sx={{
          minHeight: 20,
          lineHeight: "20px",
          mx: 0,
          mt: 0.25,
        }}
      >
        {message || "\u00A0"}
      </FormHelperText>
    </FormControl>
  );
}

export default memo(IpdFormField);
